import api from '@pray/shared/utils/api';
import { ObjectResponse } from '@pray/shared/utils/api/types/response';

import { ApiEmailSendersResponse, UpdateEmailSendersRequest } from './types';

type UpdateArtistEmailSendersProps = {
  artistId: string;
  data: UpdateEmailSendersRequest;
};

export const updateArtistEmailSenders = async ({ artistId, data }: UpdateArtistEmailSendersProps) => {
  if (!artistId) throw Error('Artist ID is required');

  const url = `/web/studio/artists/${artistId}/emails/senders`;

  const response = await api.executePutRequest<ObjectResponse<ApiEmailSendersResponse>>(url, data);

  return response.data;
};
